import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-24 right-4 z-40 w-12 h-12 bg-brand-orange text-white rounded-full shadow-lg hover:bg-brand-orange-hover transition-all hover:scale-110 flex items-center justify-center"
      aria-label="Scroll to top"
      data-testid="scroll-to-top"
    >
      <ChevronUp className="w-6 h-6" />
    </button>
  );
}
